module.exports = __webpack_public_path__ + "static/media/126_X_40-02.351524df.svg";